import * as TABLE from 'constant/table'
import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Table } from 'antd'
import { getArticleAttachments } from 'action/article'
import formatSortOrder from 'helper/format-sort-order'
import PropTypes from 'prop-types'
import _ from 'lodash'

const AttachmentTable = ({ columns, dataset, getArticleAttachments, attachments, loadingAttachments }) => {
  const [pagination, setPagination] = useState({ current: null, total: null })

  useEffect(() => {
    setPagination({ current: attachments.currentPage, total: attachments.full_count })
  }, [attachments])

  const onChange = (pagination, filters, sorter) => {
    const start = `${(pagination.current - TABLE.ONE) * TABLE.PAGE_SIZE}`
    const direction = formatSortOrder(sorter.order, TABLE.ACENDING)
    getArticleAttachments(dataset.uuid, sorter.field, direction, Number(start), true)
  }

  if (!_.isEmpty(attachments[dataset.uuid])) {
    attachments = attachments[dataset.uuid]
  }

  return (
    <Table
      columns={_.values(columns[TABLE.ATTACHMENTS])}
      dataSource={attachments.results}
      loading={loadingAttachments}
      onChange={onChange}
      pagination={attachments.full_count > TABLE.PAGE_SIZE && pagination}
      rowKey={(dataset) => dataset.uuid}
      scroll={{ x: TABLE.SCROLL, y: TABLE.SCROLL_DOWN }}
    />
  )
}

AttachmentTable.propTypes = {
  attachments: PropTypes.object,
  columns: PropTypes.object,
  dataset: PropTypes.object,
  getArticleAttachments: PropTypes.func,
  loadingAttachments: PropTypes.bool
}

const mapStateToProps = (state) => ({
  attachments: state.article.attachments,
  columns: state.table.shownColumns,
  loadingAttachments: state.article.loadingAttachments
})

const mapDispatchToProps = (dispatch) => ({
  getArticleAttachments: bindActionCreators(getArticleAttachments, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentTable)
